module.exports = __webpack_public_path__ + "img/opensans-bold-webfont.fc16469d.svg";